import React from 'react'
import { Input, Select, DatePicker } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select
const { RangePicker } = DatePicker

const SurgeryFilters = ({
  searchText,
  setSearchText,
  surgeryTypeFilter,
  setSurgeryTypeFilter,
  urgencyFilter,
  setUrgencyFilter,
  statusFilter,
  setStatusFilter,
  dateRange,
  setDateRange,
  surgeryTypes
}) => {
  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search by patient, surgery type, or surgeon'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 300 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Surgery Type'
        style={{ width: 200 }}
        value={surgeryTypeFilter}
        onChange={(value) => setSurgeryTypeFilter(value)}
      >
        <Option value='all'>All Surgery Types</Option>
        {surgeryTypes.map((type) => (
          <Option key={type} value={type}>
            {type}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Urgency'
        style={{ width: 150 }}
        value={urgencyFilter}
        onChange={(value) => setUrgencyFilter(value)}
      >
        <Option value='all'>All Urgencies</Option>
        <Option value='Emergency'>Emergency</Option>
        <Option value='Urgent'>Urgent</Option>
        <Option value='Elective'>Elective</Option>
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        <Option value='Ready'>Ready</Option>
        <Option value='Scheduled'>Scheduled</Option>
        <Option value='Pending'>Pending</Option>
        <Option value='Prep Delay'>Prep Delay</Option>
      </Select>

      <RangePicker onChange={(dates) => setDateRange(dates)} style={{ width: 280 }} />
    </div>
  )
}

export default SurgeryFilters
